import { useEffect, useState } from 'react';
import { useApi } from '@bumble/app/hooks/use-api';
import { apiError } from '@bumble/app/utils/api-error';
import {
  Box,
  Button,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  SelectChangeEvent,
} from '@mui/material';
import { useMutation, useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { Loading } from '../Loading';

interface RouterResetLANPortProps {
  cpeId: string;
  onSubmit: () => void;
}

export const RouterResetLANPort = ({ cpeId, onSubmit }: RouterResetLANPortProps) => {
  const api = useApi();

  const [interfaces, setInterfaces] = useState<string[]>([]);
  const [selectedInterface, setSelectedInterface] = useState<string>('');

  const { data } = useQuery(
    ['interfaces', cpeId],
    api.getLanInterfacesApiV1GetCpeLanInterfacesGet.bind(null, {
      cpe_id: cpeId,
    }),
    { enabled: true },
  );

  useEffect(() => {
    if (data?.data) setInterfaces(data.data);
  }, [data]);

  const resetInterfaceMutation = useMutation(api.resetInterfaceApiV1ResetInterfacePost, {
    onSuccess() {
      toast.success(`Successfully reset interface ${selectedInterface} on node ${cpeId}.`);
      onSubmit();
    },
    onError: apiError
  });

  const handleChange = ({ target: { value }}: SelectChangeEvent): void => {
    setSelectedInterface(value);
  };

  const handleSubmit = () => {
    if (selectedInterface) {
      resetInterfaceMutation.mutate({
        node_id: cpeId,
        interface: selectedInterface
      });
    } else {
      toast.error('Please choose an interface first.');
    }
  };

  return (
    <Box pt={2}>
      {resetInterfaceMutation.isLoading ? <Loading content='Loading...' height={30} /> :
        <Box display="flex" justifyContent="center" sx={{ mb: 4 }}>
          <FormControl fullWidth>
            <InputLabel id="reset-LAN-port">Interface</InputLabel>
            <Select
              labelId="reset-LAN-port"
              value={selectedInterface}
              onChange={handleChange}
            >
              { interfaces && interfaces.map((item, i) => {
                return <MenuItem value={item} key={item}>{item}</MenuItem>;
              })}
            </Select>
          </FormControl>
        </Box>
      }
      <Box display="flex" justifyContent="flex-end" sx={{ mt: 5 }}>
        <Button variant="outlined" onClick={handleSubmit} disabled={!selectedInterface}>
          Confirm
        </Button>
      </Box>
    </Box>
  );
};
